const videoBlock = {
    init:() => {
        // $('m2-e-vb__video').on('click', () => {
        //     console.log('click');
        //     //
        // });

        jQuery('.m2-e-vb__video').click((e) => {
            videoBlock.showVideo(e);
        });
    },
    showVideo:(e) => {

        var el = jQuery(e.target);
        var parent = el.parent();
        var emebed = parent.find('div.embed-container');
        var url = el.attr('data-vimeo-url');
        console.log(url);

        var iframe = '<iframe src="'+url+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'; 

        emebed.html(iframe);
        el.fadeOut(250);
    }
};

export default videoBlock;